import React from 'react';
export var TableCell = function (_a) {
    var _b, _c;
    var cell = _a.cell, field = _a.field, tableStyles = _a.tableStyles, onCellFilterAdded = _a.onCellFilterAdded, columnIndex = _a.columnIndex, columnCount = _a.columnCount, dataRowIndex = _a.dataRowIndex;
    var cellProps = cell.getCellProps();
    if (!field.display) {
        return null;
    }
    if (cellProps.style) {
        cellProps.style.minWidth = cellProps.style.width;
        cellProps.style.justifyContent = cell.column.justifyContent;
    }
    var innerWidth = ((_b = cell.column.width) !== null && _b !== void 0 ? _b : 24) - tableStyles.cellPadding * 2;
    // last child sometimes have extra padding if there is a non overlay scrollbar
    if (columnIndex === columnCount - 1) {
        innerWidth -= tableStyles.lastChildExtraPadding;
    }
    var link = (_c = field.getLinks) === null || _c === void 0 ? void 0 : _c.call(field, {
        valueRowIndex: dataRowIndex,
    })[0];
    var onClick;
    if (link === null || link === void 0 ? void 0 : link.onClick) {
        onClick = function (event) {
            // Allow opening in new tab
            if (!(event.ctrlKey || event.metaKey || event.shiftKey) && link.onClick) {
                event.preventDefault();
                link.onClick(event);
            }
        };
    }
    var renderedCell = cell.render('Cell', {
        field: field,
        tableStyles: tableStyles,
        onCellFilterAdded: onCellFilterAdded,
        cellProps: cellProps,
        innerWidth: innerWidth,
    });
    return link ? (React.createElement("a", { href: link.href, onClick: onClick, target: link.target, title: link.title, className: tableStyles.cellLink }, renderedCell)) : (React.createElement(React.Fragment, null, renderedCell));
};
//# sourceMappingURL=TableCell.js.map